module.exports = " <i *ngIf=\"authenticationService.isLogged\"> <custom-header [(menuOpen)]=\"authenticationService.isOpenMenuModule\" (onClickOpenMenu)=\"changeMenuModuleState($event)\" (onClickChangePass)=\"onClickChangePass()\" (onClickLogout)=\"onClickLogout()\"> </custom-header> <menu-selector-module></menu-selector-module> <notification-alert></notification-alert> </i> <router-outlet></router-outlet> <i *ngIf=\"authenticationService.isLogged\"> <custom-footer *ngIf=\"authenticationService.userLogged\" [(isLoading)]=\"isLoading\"></custom-footer> </i> ";


//////////////////
// WEBPACK FOOTER
// ./app/app.component.html
// module id = 1112
// module chunks = 7